import styled from "styled-components";
import { Col } from "react-bootstrap";
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Button } from 'react-bootstrap';

export const StreetName = styled.div`
    width: 96%;
    text-align: center;
    color: black;
    box-shadow: 0 4px 10px -2px #E3E3E3;
    background-color: #FAFAFA;
    border-radius: 10px;
    display: flex;
    margin: 15px auto;
    justify-content: space-around;
    flex-wrap: wrap;
    flex-direction: row;
    padding: 16px 0;
    align-items: center;
`;

export const MyCol = styled(Col)`
    display: flex;
    justify-content: space-between;
    flex-flow: column wrap;
    align-items: center;
    @media (max-width: 768px) {
        margin: 7px;
    }
`;

export const PDFLink = styled(PDFDownloadLink)`
    color: #808080;
    text-decoration: none;
    border-radius: 4px;
    background: #EEEEEE;
    outline: none;
    border: none;
    cursor: pointer;
    height: 50px;
    width: 175px;
    line-height: 50px;
    &:hover {
        transition: all 0.2s ease-in-out;
        background: #fff;
        color: #808080;
    }
`;

export const PDFDownload = styled(Button)`
    color: #808080;
    text-decoration: none;
    border-radius: 4px;
    background: #EEEEEE;
    outline: none;
    border: none;
    cursor: pointer;
    height: 50px;
    width: 175px;
    &:hover {
        transition: all 0.2s ease-in-out;
        background: #fff;
        color: #808080;
    }
`;